// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This replaces BaseSuperAdmin class with a factory function that uses BaseApiServiceFactory

import { createBaseApiService, type IBaseApiService } from "@Front/Api/BaseApiServiceFactory";

export interface IBaseSuperAdmin extends IBaseApiService {
	namespaceUrl: string;
}

export function createBaseSuperAdmin(): IBaseSuperAdmin {
	const baseApi = createBaseApiService();

	return {
		...baseApi,
		get namespaceUrl(): string {
			return baseApi.getBaseUrl().concat("/super-admin");
		},
	};
}
